<template>
  <div class="col-lg-6">
    <div class="card">
      <!-- <div class="card-header">
        <h4 class="card-title">Promjena lozinke</h4>
      </div> -->
      <div class="card-body custom-alert">
        <b-alert
          v-model="formNotCorrect"
          v-height-fade.appear
          variant="danger"
          dismissible
          class="mb-0"
        >
          <div class="alert-body">
            Forma nije ispravno popunjena!
          </div>
        </b-alert>
      </div>
      <div class="card-body">
        <validation-observer ref="connectForm">
          <b-form @submit.prevent="submitForm">
            <b-row>
              <!-- UREDJAJ -->
              <b-col cols="12">
                <b-form-group
                  label="Uređaj"
                  label-for="device"
                  label-cols-md="4"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="device"
                    vid="device"
                    rules="required"
                  >
                    <vue-autosuggest
                      :suggestions="filteredDeviceOptions"
                      @selected="onDeviceSelected"
                      :limit="10"
                      :input-props="{
                        id: 'autosuggest__input',
                        class: 'form-control',
                        placeholder: 'Izaberite uređaj',
                      }"
                      @input="deviceOnInputChange"
                      v-model="model.deviceName"
                    >
                      <template slot-scope="{ suggestion }">
                        <div class="my-suggestion-item">
                          {{ suggestion.item.name }}
                          <b>{{ " (" + suggestion.item.pkDeviceId + ")" }}</b>
                        </div>
                      </template>
                    </vue-autosuggest>
                    <div class="text-danger">{{ errors[0] }}</div>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- GRLO -->
              <b-col cols="12">
                <b-form-group label="Grlo" label-for="cow" label-cols-md="4">
                  <validation-provider
                    #default="{ errors }"
                    name="cow"
                    vid="cow"
                    rules="required"
                  >
                    <vue-autosuggest
                      :suggestions="filteredCowOptions"
                      @selected="onCowSelected"
                      :limit="10"
                      :input-props="{
                        id: 'autosuggest__input',
                        class: 'form-control',
                        placeholder: 'Izaberite grlo',
                      }"
                      @input="cowOnInputChange"
                      v-model="model.cowName"
                    >
                      <template slot-scope="{ suggestion }">
                        <div class="my-suggestion-item">
                          {{ suggestion.item.name }}
                        </div>
                      </template>
                    </vue-autosuggest>
                    <div class="text-danger">{{ errors[0] }}</div>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- submit and reset -->
              <b-col offset-md="4">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  class="mr-1"
                >
                  Poveži
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BInputGroup,
  BInputGroupPrepend,
  BRow,
  BCol,
  BAlert,
} from "bootstrap-vue";
import { VueAutosuggest } from "vue-autosuggest";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import { heightFade } from "@core/directives/animations";
import { required, min, confirmed } from "@validations";
import store from "@/store/index";
import { mapState } from "vuex";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BAlert,
    VueAutosuggest,
  },
  directives: {
    "height-fade": heightFade,
    Ripple,
  },
  beforeRouteEnter(to, from, next) {
    let getAllUnlinkedCattleAndDevices = store.dispatch(
      "cattle/GET_ALL_UNLINKED_CATTLE_AND_DEVICES"
    );

    Promise.all([getAllUnlinkedCattleAndDevices]).then(() => {
      next();
    });
  },
  beforeDestroy() {
    store.commit("cattle/SET_COW");
  },
  data() {
    return {
      filteredDeviceOptions: [],
      filteredCowOptions: [],
      model: {
        deviceName: "",
        deviceId: 0,
        cowId: 0,
        cowName: "",
      },
      formNotCorrect: false,
    };
  },
  created() {
    if (this.$route.query.deviceId) {
      this.model.deviceId = this.$route.query.deviceId;
      let device = this.unlinkedDevices.find(
        (d) => d.pkDeviceId === this.$route.query.deviceId
      );
      this.model.deviceName = device.name + " (" + device.pkDeviceId + ")";
    }

    if (this.$route.query.cowId) {
      this.model.cowId = this.$route.query.cowId;
      let cow = this.unlinkedCattle.find(
        (d) => d.pkCowId === this.$route.query.cowId
      );
      console.log(this.unlinkedCattle);
      this.model.cowName = cow.name + " (" + cow.earringNumber + ")";
    }
  },
  mounted() {
    localize("en", {
      code: "en",
      fields: {
        device: {
          required: "Polje je obavezno",
        },
        cow: {
          required: "Polje je obavezno",
        },
      },
    });
  },
  computed: {
    ...mapState({
      unlinkedCattle: (state) => state.cattle.unlinkedCattle,
      unlinkedDevices: (state) => state.cattle.unlinkedDevices,
    }),
  },
  methods: {
    onDeviceSelected(option) {
      this.model.deviceId = option.item.pkDeviceId;

      let newDeviceName =
        option.item.name + " (" + option.item.pkDeviceId + ")";
      if (this.model.deviceName !== newDeviceName)
        this.model.deviceName = newDeviceName;
    },
    onCowSelected(option) {
      this.model.cowId = option.item.pkCowId;
      this.model.cowName =
        option.item.name + " (" + option.item.earringNumber + ")";
    },
    deviceOnInputChange(text) {
      this.model.deviceId = 0;
      if (text === "" || text === undefined) {
        return;
      }

      let filteredOptions = this.unlinkedDevices
        .filter(
          (item) =>
            (item.name + " (" + item.pkDeviceId + ")")
              .toLowerCase()
              .indexOf(text.toLowerCase()) > -1
        )
        .slice(0, 10);

      this.filteredDeviceOptions = [
        {
          data: filteredOptions,
        },
      ];
    },
    cowOnInputChange(text) {
      this.model.cowId = 0;
      if (text === "" || text === undefined) {
        return;
      }

      let filteredOptions = this.unlinkedCattle;

      this.filteredCowOptions = [
        {
          data: filteredOptions,
        },
      ];
    },
    submitForm() {
      var $this = this;
      $this.formNotCorrect = false;
      this.$refs.connectForm.validate().then((success) => {
        if ($this.model.cowId == 0 || $this.model.deviceId == 0) {
          $this.formNotCorrect = true;
        } else {
          store
            .dispatch("cattle/LINK_COW_AND_DEVICE", $this.model)
            .then((response) => {
              $this.$swal({
                position: "bottom-end",
                icon: "success",
                title:
                  "Uspješno ste povezali grlo " +
                  $this.model.cowName +
                  " sa uređajem " +
                  $this.model.deviceName,
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                buttonsStyling: false,
              });
              $this.$router.push({ name: "CattleIndex" });
            })
            .catch((error) => {});
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-alert {
  padding-bottom: 0;
}
.form-control:disabled {
  background-color: white;
}
</style>
